"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _formatters = require("../../utils/formatters");
var _types = require("../../utils/types");
var _ImageIcon = _interopRequireDefault(require("../common/ImageIcon/ImageIcon"));
var _Stopwatch = _interopRequireDefault(require("../common/Stopwatch/Stopwatch"));
var _helpers = require("../../utils/helpers");
require("./TwitterListItem.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var TwitterListItem = function TwitterListItem(_ref) {
  var id = _ref.id,
    text = _ref.text,
    media = _ref.media,
    unread = _ref.unread,
    date = _ref.date,
    _ref$contact = _ref.contact,
    user = _ref$contact.name,
    handle = _ref$contact.account,
    campaign = _ref.campaign,
    active = _ref.active,
    timeUnattended = _ref.timeUnattended,
    warning = _ref.warning,
    onClick = _ref.onClick;
  var _useTranslation = (0, _reactI18next.useTranslation)('commons'),
    t = _useTranslation.t,
    i18n = _useTranslation.i18n;
  var lang = i18n.language.slice(0, 2);
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: id,
    className: "uin-list-item uin-tli-tweet-card ".concat(active ? 'active' : '', " ").concat(warning ? 'warning' : ''),
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-lic-bar"
  }), unread && /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-lic-dot"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-tli-tc-info"
  }, /*#__PURE__*/_react["default"].createElement(_ImageIcon["default"], {
    name: campaign.name,
    image: campaign.image
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-tli-tc-contact"
  }, /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "uin-tli-username"
  }, user), /*#__PURE__*/_react["default"].createElement("span", {
    className: "spacer"
  }, '·'), /*#__PURE__*/_react["default"].createElement("time", {
    dateTime: date
  }, (0, _formatters.formatTimeShort)(date, lang))), /*#__PURE__*/_react["default"].createElement("span", null, handle)), timeUnattended !== null && /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-lic-timeout"
  }, /*#__PURE__*/_react["default"].createElement(_Stopwatch["default"], {
    initialTime: timeUnattended
  })), /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon twitter uin-lic-icon"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-tli-tc-content"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-tli-tc-text"
  }, text || /*#__PURE__*/_react["default"].createElement("em", {
    className: "uin-lic-new-ph"
  }, t('new-convo'))), media && /*#__PURE__*/_react["default"].createElement("div", {
    className: 'uin-tli-tc-media' + (media.length > 1 ? ' contain' : '')
  }, (0, _helpers.groupImages)(media))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-tli-tc-footer"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "date"
  }, (0, _formatters.formatDateLong)(date, lang))));
};
TwitterListItem.propTypes = {
  id: _propTypes["default"].number,
  date: _propTypes["default"].instanceOf(Date).isRequired,
  text: _propTypes["default"].string,
  media: _propTypes["default"].arrayOf(_propTypes["default"].string),
  unread: _propTypes["default"].bool,
  contact: _types.contactType.isRequired,
  campaign: _types.campaignType.isRequired,
  active: _propTypes["default"].bool,
  timeUnattended: _propTypes["default"].instanceOf(Date),
  warning: _propTypes["default"].bool,
  onClick: _propTypes["default"].func.isRequired
};
TwitterListItem.defaultProps = {
  timeUnattended: null
};
var _default = exports["default"] = TwitterListItem;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/TwitterListItem/TwitterListItem.js
// module id = 1427
// module chunks = 0